import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import { Network, ReactionType, useAddReactionAnalyticsMutation } from 'api';
import { Events } from 'analytics';
import { useContent } from 'hooks';
import { SocialButton } from 'components';
import { popup } from 'utilities';

const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';
const LINKEDIN_SHARE_URL = 'https://www.linkedin.com/shareArticle';

const ShareSocial: FC = () => {
  const content = useContent();
  const { content_object, content_id } = content;
  const shareUrl = content_object.url || window.location.href;

  const { mutate: addReactionAnalytics } = useAddReactionAnalyticsMutation();

  function handleReactionAnalytics() {
    addReactionAnalytics({
      content_id,
      reaction_type: ReactionType.Share,
    });
  }

  function handleTracking(network: Network) {
    window?.analytics?.track(Events.PublicPostShareInitiated, {
      content_id: content.content_id,
      linkedin: network === Network.Linkedin,
      twitter: network === Network.Twitter,
      facebook: network === Network.Facebook,
    });

    return handleReactionAnalytics();
  }

  function handleFacebookShare() {
    window?.FB?.ui(
      {
        method: 'share',
        href: shareUrl,
      },
      (response: unknown) => {
        if (response) {
          window?.analytics?.track(Events.PublicPostShareCompleted, {
            facebook: true,
          });
        }
      }
    );

    return handleTracking(Network.Facebook);
  }

  function handleLinkedInShare() {
    popup(`${LINKEDIN_SHARE_URL}?mini=true&url=${shareUrl}`, 'LinkedIn', 650, 650);
    return handleTracking(Network.Linkedin);
  }

  return (
    <Grid container spacing={1}>
      <Grid item>
        <SocialButton
          target="_blank"
          network={Network.Twitter}
          text="Twitter"
          onClick={() => handleTracking(Network.Twitter)}
          href={`${TWITTER_SHARE_URL}?url=${shareUrl}`}
        />
      </Grid>
      <Grid item>
        <SocialButton network={Network.Linkedin} text="LinkedIn" onClick={handleLinkedInShare} />
      </Grid>
      <Grid item>
        <SocialButton network={Network.Facebook} text="Facebook" onClick={handleFacebookShare} />
      </Grid>
    </Grid>
  );
};

export default ShareSocial;
